/**
 * @file 产品板块列表页
 * @author WenCe
 * */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import TopBar from '../../components/TopBar';
import classnames from 'classnames';
import {connect} from 'react-redux';

import {fetchCmsapiProductList} from '../../actions/productCenterAction';
import './index.less';

class ProductCenter extends PureComponent {
    static propTypes = {
        defaultExpand: PropTypes.bool,
        cmapiProductList: PropTypes.object,
        fetchCmsapiProductList: PropTypes.func
    };
    static defaultProps = {
        defaultExpand: true
    };

    constructor(props) {
        super(props);

        this.state = {
            taggleIds: []
        };

        this.renderList = this.renderList.bind(this);
        this.taggleCollapse = this.taggleCollapse.bind(this);
        this.onClickRoot = this.onClickRoot.bind(this);
        this.onClickChildren = this.onClickChildren.bind(this);
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = '/productCenter';
        }
    }

    componentDidMount() {
        this.props.fetchCmsapiProductList().then(() => {
            const {defaultExpand, cmapiProductList} = this.props;
            const itemList = cmapiProductList && cmapiProductList.itemlist;
            if (defaultExpand && itemList) {
                const taggleIds = itemList.map((_, index) => index);

                this.setState({taggleIds});
            }
        });
    }

    onClickRoot(id) {
        const index = this.state.taggleIds.indexOf(id);

        let newTargetIds = [].concat(this.state.taggleIds);
        if (index === -1) {
            newTargetIds.push(id);
        }
        else {
            newTargetIds.splice(index, 1);
        }

        this.setState({taggleIds: newTargetIds});
    }

    onClickChildren(id) {
        location.href = `/m/productDetail/${id}`;
    }

    taggleCollapse(isRoot, id, e) {
        e.persist();
        isRoot ? this.onClickRoot(id) : this.onClickChildren(id);
    }

    renderList(list, isRoot) {
        return list && list.map((item, index) => {
            const hasChild = item && item.children && item.children.length > 0;
            const taggleIdIndex = this.state.taggleIds.indexOf(index);
            const isShowItemList = taggleIdIndex >= 0;
            return (
                <div
                    key={item.navigation_id || index}
                    className={classnames({'root': isRoot, 'sub-list': !isRoot})}>
                    {isRoot
                        ? <div onClick={this.taggleCollapse.bind(this, isRoot, index)} className="item-title">
                            <span className="vertical-line"></span>
                            {item && item.navigation_name}
                            <span className={classnames('fold', {active: isShowItemList})}>
                                <img alt="unfold" src={require('../../asset/svg/unfold.svg')}/>
                            </span>
                        </div>
                        : <div onClick={this.taggleCollapse.bind(this, isRoot, item && item.id)} className="item-card">
                            <span className="item-card-icon">
                                <img src={item && item.icon} alt="icon"/>
                            </span>
                            {item && item.name}
                        </div>}

                    {
                        hasChild
                        && <div className={classnames('item-list', {active: isShowItemList})}>
                            {this.renderList(item.children)}
                        </div>
                    }
                </div>
            );
        });
    }

    render() {
        const cmapiProductList = this.props.cmapiProductList;
        const taggleIds = this.state.taggleIds;
        return (
            <div className="product-list pr">
                {!this.isPC()
                && <div className="top-bar-box pr">
                    <TopBar typeLeft={false}/>
                </div>}
                <div className="body">
                    <h1 className="product-center-title">产品板块</h1>
                    {cmapiProductList && this.renderList(cmapiProductList.itemlist, true)}
                </div>

                {
                    cmapiProductList.itemlist && taggleIds.length === cmapiProductList.itemlist.length
                        ? <div className="loading-box" style={{paddingTop: '.85rem', paddingBottom: '1.05rem'}}>
                            <div className="loading pr">
                                <div className="conter">你已到达版块尽头</div>
                            </div>
                        </div>
                        : ''
                }
            </div>
        );
    }
}

export default connect(
    state => ({cmapiProductList: state.cmapiProductList}),
    dispatch => ({
        fetchCmsapiProductList: (...args) => dispatch(fetchCmsapiProductList(...args))
    })
)(ProductCenter);



// WEBPACK FOOTER //
// ./src/containers/productCenter/index.js